module.exports = __webpack_public_path__ + "static/media/cross-dark.73319a97.svg";